import { render, staticRenderFns } from "./FormFieldsetAnchor.vue?vue&type=template&id=6f49c21e"
import script from "./FormFieldsetAnchor.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFieldsetAnchor.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports